import React, { useState } from "react";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

const Sidebar = ({ items }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div
      style={{
        width: isOpen ? "250px" : "60px", // Collapsible width
        transition: "width 0.3s ease", // Smooth transition
        backgroundColor: "#343a40", // Sidebar background color
        color: "white", // Text color
        height: "100vh", // Full height of viewport
        overflow: "hidden", // Prevent content overflow
      }}
    >
      {/* Sidebar Toggle Button */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: isOpen ? "space-between" : "center", // Adjust content alignment
          padding: "10px 15px",
          cursor: "pointer",
          borderBottom: "1px solid #495057", // Divider line
        }}
        onClick={() => setIsOpen(!isOpen)} // Toggle sidebar visibility
      >
        <span style={{ fontSize: "1.5em" }}>☰</span>
        {isOpen && <span style={{ marginLeft: "10px" }}>Menu</span>}
      </div>

      {/* Sidebar Items */}
      <Nav className="flex-column" style={{ marginTop: "10px" }}>
        {items.map((item, index) => (
          <Nav.Link
            key={index}
            as={Link}
            to={item.link}
            style={{
              color: "white",
              padding: "10px 15px",
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
            }}
          >
            {/* Icon */}
            <span
              style={{
                fontSize: "1.5em",
                marginRight: isOpen ? "10px" : "0",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "30px", // Maintain icon alignment
              }}
            >
              {item.icon}
            </span>
            {/* Name */}
            {isOpen && <span>{item.name}</span>}
          </Nav.Link>
        ))}
      </Nav>
    </div>
  );
};

export default Sidebar;
